import { all, takeLatest, put, take } from 'redux-saga/effects';
import { StartupTypes } from './startup.redux';
import { AuthActions } from '../auth';
import { ContentRegistryActions, ContentRegistryTypes } from '../contentRegistry';
import { ROUTES } from '../../routes/routes';
import { getLocationPathname } from '../../shared/utils/location';
import { RouterActions } from '../router';

function* startup() {
  yield put(RouterActions.listen());

  const locationStartsWithKioskRoute = getLocationPathname().indexOf(ROUTES.kioskBase) === 0;

  if (locationStartsWithKioskRoute) {
    yield put(ContentRegistryActions.rehydrate());
    yield take(ContentRegistryTypes.REHYDRATE_SUCCESS);
  }

  yield put(AuthActions.listenForAuth());
  yield put(ContentRegistryActions.fetchAppConfig());
  yield put(ContentRegistryActions.fetchAllMarkets());
}

export default function* startupSaga() {
  yield all([takeLatest(StartupTypes.STARTUP, startup)]);
}
